import './scss/rivandy.scss';
import './scss/ranking.scss';
import React, { useState } from 'react';
import { useEffect } from 'react';
import Video from './Video';
import Faction from './Faction';
import { useSelector } from 'react-redux';
import Fade from 'react-reveal/Fade';
import axios from 'axios';
import { Link } from 'react-router-dom';

function Ranking() {


  const settings = useSelector(state => state);
  const [classement, setRank] = useState(null);
  const [total, setTotal] = useState(0);


  const [filterName, setFilterName] = useState('');
  const [numberPerPage, setNumberPerPage] = useState(50);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      await axios.get(`https://rivandy.com:3003/game/GetRanking?pageNumber=${pageNumber}&filterName=${filterName}&numberPerPage=${numberPerPage}`).then((result) => {
        setRank(result.data.result);
        setTotal(result.data.total);
        setHasError(false)
      }).catch((e) => {
        setRank(null);
        setTotal(0);
        setHasError(true)
      })


    }
    fetch();
  }, [filterName, numberPerPage, pageNumber]);

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const handleFilterChange = (event) => {
    setFilterName(event.target.value);
  };

  const handleNumberPerPageChange = (event) => {
    setNumberPerPage(Number(event.target.value));
  };

  const resolveRankBadge = (rankedPoint, absoluteRank) => {
    if (absoluteRank === 1) {
      return { src: '/Img/ranking/master.png', label: 'Master' };
    }
    if (rankedPoint >= 350) {
      return { src: '/Img/ranking/master.png', label: 'Master' };
    }
    if (rankedPoint >= 250) {
      return { src: '/Img/ranking/emeraude.png', label: 'Emeraude' };
    }
    if (rankedPoint >= 150) {
      return { src: '/Img/ranking/gold.png', label: 'Gold' };
    }
    if (rankedPoint >= 50) {
      return { src: '/Img/ranking/silver.png', label: 'Silver' };
    }
    return { src: '/Img/ranking/bronze.png', label: 'Bronze' };
  };

  const itemsPerPage = Number(numberPerPage) || 1;
  const result = classement && classement.map((joueur, index) => {
    const rankedPoint = Number(joueur.rankedPoint) || 0;
    const absoluteRank = (pageNumber - 1) * itemsPerPage + index + 1;
    const { src: rankSrc, label: rankLabel } = resolveRankBadge(rankedPoint, absoluteRank);
    return (
      <tr key={joueur.userId || joueur.accountId || joueur.username || joueur.steamprofile}>
        <td key={absoluteRank}>{absoluteRank}</td>
        <td className='nameTD'>
          <div className='nameTD__inner'>
            {joueur.avatarId && typeof joueur.avatarId === 'string' && joueur.avatarId.startsWith('http') ? (
              <Link to={`/player/${joueur.userId}`}>
                <img src={joueur.avatarId} alt={joueur.username} />
              </Link>
            ) : null}
            <Link to={`/player/${joueur.userId}`}>{joueur.username}</Link>
          </div>
        </td>
        <td className='rankBadgeTD'><img src={rankSrc} alt={`${rankLabel} rank`} /></td>
        <td>{joueur.rankedPoint}</td>
        {/* <td>{joueur.win} - {joueur.lose}</td> */}
      </tr>
    )
  });


  return (
    [<section className='rankingPage separator'>
      <section id="ranking-section">
        <section>


          <aside className='filterPage'>
            <aside className='textFilter'>
              <label>Filter</label>
              <input type="text" value={filterName} onChange={handleFilterChange} />
            </aside>
            <aside className='numberPerPageFilter'>
              <article>
                {total / numberPerPage < pageNumber && pageNumber > 1 ? <button onClick={() => handlePageChange(pageNumber - 1)}>Previous</button> : null}
                {pageNumber > 2 ? <button onClick={() => handlePageChange(1)}>1</button> : null}
                {total / numberPerPage > pageNumber - 1 && pageNumber > 1 ? <button onClick={() => handlePageChange(pageNumber - 1)}>{pageNumber - 1}</button> : null}
                <button className='selectedPage' disabled> {pageNumber}</button>
                {Math.ceil(total / numberPerPage) >= pageNumber + 1 ? <button onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</button> : null}
                {/* Vous pouvez ajouter autant de boutons de page supplémentaires que nécessaire */}
                {total / numberPerPage > pageNumber ? <button onClick={() => handlePageChange(pageNumber + 1)}>Next</button> : null}

              </article>
              <select value={numberPerPage} onChange={handleNumberPerPageChange}>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>

            </aside>

          </aside>


          <table id="tableRank" cellSpacing="0">
            <tr className='tableTitles'><th>RANK</th><th className='nameTH'>NAME</th><th className='rankBadgeTH'>RANG</th><th>SCORE (RP)</th></tr>
            {result}
            {hasError ? <p className='error'>We couldn't find any matches. Would you like to try another search?</p> : null}
          </table>
        </section>
      </section>
    </section>]
  );
}

export default Ranking;
